import { FormattedMessage } from "react-intl";
import React from "react";
import { NOTIFICATION_TYPES, isTeachingNotification } from "../../../../../notification-constants";
import { from } from "@apollo/client";

export const getNotificationTypeHeadline = (notificationType) => {
  if (isTeachingNotification(notificationType)) {
    return <FormattedMessage id="general.private-tutoring" />;
  }
  return false;
};

export const wasPrevNotifSameType = (
  notificationType,
  prevNotificationType
) => {
  // Need to check props.id, cause FormattedMessage is returned
  return (
    getNotificationTypeHeadline(notificationType).props.id ===
    getNotificationTypeHeadline(prevNotificationType)?.props?.id
  );
};

/**
 * Generate the appropriate link for a notification based on its type
 * @param {string} notificationType - The type of notification
 * @param {string} courseId - The course ID
 * @param {string} contentId - The content ID
 * @returns {string} The generated link or empty string for chat-based notifications
 */
export const getNotificationLink = (notificationType, courseId, contentId) => {
  switch (notificationType) {
    case NOTIFICATION_TYPES.NEW_TEACHING:
      return `/courses/${courseId}/teachers/${contentId}`;
    case NOTIFICATION_TYPES.TEACHING_REQUEST:
    case NOTIFICATION_TYPES.TEACHING_REQUEST_ANSWER:
      // These types open chat instead of navigating to a link
      return "";
    case NOTIFICATION_TYPES.NEW_VIDEO:
      return `/courses/${courseId}/videos/${contentId}`;
    case NOTIFICATION_TYPES.NEW_QUESTION:
      return `/courses/${courseId}/questions/${contentId}`;
    case NOTIFICATION_TYPES.NEW_LINK:
      return `/courses/${courseId}/links/${contentId}`;
    case NOTIFICATION_TYPES.NEW_GROUP:
      return `/courses/${courseId}/groups/${contentId}`;
    case NOTIFICATION_TYPES.NEW_QUESTION_ANSWER:
      return `/courses/${courseId}/questions/${contentId}`;
    default:
      return "";
  }
};
